(function () {
  var tries = 0;
  var CDN = 'https://cdn.shopify.com/s/files/1/0917/4718/files/';
  var SS = 'https://cdn.ssactivewear.com/Images/Color/';
  var VIEWS = [['f', 'Front'], ['b', 'Back'], ['s', 'Side'], ['omf', 'On model']];
  var RX = /Color\/(\d+)_(f|b|s|omf)_(fm|fl)\.jpg/;
  var MIN = 12;

  var OWN = {
    '102a': {
      'cardinalblack': 'Threadfast_Apparel_102A_Cardinal_Black_Triblend_DirectSide_High.jpg?v=1790159809',
      'cream':         'Threadfast_Apparel_102A_Cream_Triblend_DirectSide_High.jpg?v=1790159808',
      'green':         'Threadfast_Apparel_102A_Green_Triblend_DirectSide_High.jpg?v=1790159809',
      'grey':          'Threadfast_Apparel_102A_Grey_Triblend_DirectSide_High.jpg?v=1790159809',
      'mint':          'Threadfast_Apparel_102A_Mint_Triblend_DirectSide_High.jpg?v=1790159809',
      'royalblack':    'Threadfast_Apparel_102A_Royal_Black_Triblend_DirectSide_High.jpg?v=1790159809',
      'royal':         'Threadfast_Apparel_102A_Royal_Triblend_DirectSide_High.jpg?v=1790159809',
      'solidblack':    'Threadfast_Apparel_102A_Black_Triblend_DirectSide_High.jpg?v=1790159809',
      'black':         'Threadfast_Apparel_102A_Black_Triblend_DirectSide_High.jpg?v=1790159809',
      'navy':          'Threadfast_Apparel_102A_Navy_Triblend_DirectSide_High.jpg?v=1790159809',
      'orange':        'Threadfast_Apparel_102A_Orange_Triblend_DirectSide_High.jpg?v=1790159809'
    }
  };
  function colorKey(name) {
    return String(name || '').toLowerCase().replace(/tri-?blend/g, '').replace(/[^a-z0-9]+/g, '');
  }
  function ownPhoto(st, color, width) {
    if (!st || !color) return '';
    var set = OWN[String(st.s || '').toLowerCase()];
    if (!set) return '';
    var file = set[colorKey(color[0])];
    return file ? CDN + file + '&width=' + (width || 600) : '';
  }
  function colorFor(card, st, f, hex) {
    if (!st || !st.c) return null;
    var dot = null;
    try { dot = card && card.querySelector('.dot:hover'); } catch (err) {}
    if (dot && dot.getAttribute('data-ci') !== null) {
      var byIndex = st.c[+dot.getAttribute('data-ci')];
      if (byIndex) return byIndex;
    }
    if (typeof window.swatchOf === 'function') {
      var sw = window.swatchOf(st);
      if (sw && String(sw[1]).toLowerCase() === String(hex || '').toLowerCase()) return sw;
    }
    var i;
    if (f && +f) { for (i = 0; i < st.c.length; i++) if (String(st.c[i][3]) === String(f)) return st.c[i]; }
    for (i = 0; i < st.c.length; i++) if (String(st.c[i][1]).toLowerCase() === String(hex || '').toLowerCase()) return st.c[i];
    return null;
  }

  function ready() {
    return Array.isArray(window.STYLES) && window.STYLES.length && typeof window.cardHTML === 'function';
  }
  var PLAIN = { 'stanley/stella': 1 };
  function plain(e) { return !!(e && PLAIN[String(e.b || '').toLowerCase()]); }
  function numName(e) {
    var n = String(e && e.n || '');
    if (plain(e)) return n;
    return e && e.s && n.toLowerCase().indexOf(String(e.s).toLowerCase()) === -1 ? e.s + ' ' + n : n;
  }
  function wrapCards() {
    if (window.cardHTML.__rvaWrapped) return;
    var orig = window.cardHTML;
    var wrapped = function (e) {
      var html = orig.apply(this, arguments);
      if (!e || !e.s || plain(e)) return html;
      html = html.replace('<span class="cNum">' + e.s + ' · ', '<span class="cNum">');
      return html.replace('<span class="cName">' + e.n + '</span>', '<span class="cName">' + numName(e) + '</span>');
    };
    wrapped.__rvaWrapped = 1;
    window.cardHTML = wrapped;
  }
  function panelName() {
    var h = document.getElementById('pName');
    if (!h || !window.S || !window.S.open || typeof window.styleById !== 'function') return;
    var st = window.styleById(window.S.open);
    if (!st) return;
    var want = numName(st);
    if (h.textContent !== want) h.textContent = want;
  }

  function heading() {
    var h = document.querySelector('#rvaCat header.head h1');
    var S = window.S;
    if (!h || !S || document.getElementById('reqPage')) return;
    var labels = window.TYPE_LABEL || { tee: 'T-Shirts', ls: 'Long Sleeve', fleece: 'Fleece' };
    var t = Object.keys(S.type || {}), b = Object.keys(S.brand || {});
    var parts = [];
    if (b.length === 1) parts.push(b[0]);
    if (t.length === 1) parts.push(labels[t[0]] || t[0]);
    var txt = parts.length && t.length <= 1 && b.length <= 1 ? parts.join(' ') + '.' : 'The catalog.';
    if (h.textContent !== txt) h.textContent = txt;
  }
  function wrapRender() {
    if (typeof window.render !== 'function' || window.render.__rvaHead) return;
    var orig = window.render;
    var wrapped = function () {
      var out = orig.apply(this, arguments);
      try { heading(); } catch (err) {}
      return out;
    };
    wrapped.__rvaHead = 1;
    window.render = wrapped;
  }
  function navFocusCss() {
    if (document.getElementById('rvaNavFocusCss')) return;
    var st = document.createElement('style');
    st.id = 'rvaNavFocusCss';
    st.textContent = '.header__inline-menu .rva-nav-on:focus,.header__inline-menu .rva-nav-on:focus-visible{outline:none!important;box-shadow:none!important}';
    document.head.appendChild(st);
  }

  function fixAddSum(st) {
    var t = document.getElementById('addSum');
    var S = window.S;
    if (!t || !st || !S || !S.draft || typeof window.lineTotal !== 'function' || typeof window.swatchOf !== 'function') return;
    var order = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
    var sizes = Object.keys(S.draft).filter(function (k) { return S.draft[k] > 0; });
    sizes.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
    if (sizes.length < 2) return;
    var pieces = 0;
    sizes.forEach(function (k) { pieces += S.draft[k]; });
    var all = (typeof window.reqPieces === 'function' ? window.reqPieces() : 0) + pieces;
    var sw = window.swatchOf(st), groups = [], byPrice = {};
    sizes.forEach(function (k) {
      var one = {}; one[k] = 1;
      var unit = Math.round(window.lineTotal(st, sw, one, all) * 100) / 100;
      var key = unit.toFixed(2);
      if (!byPrice[key]) { byPrice[key] = { unit: unit, qty: 0, sizes: [] }; groups.push(byPrice[key]); }
      byPrice[key].qty += S.draft[k];
      byPrice[key].sizes.push(k);
    });
    if (groups.length < 2) return;
    var money = typeof window.money === 'function' ? window.money : function (n) { return '$' + n.toFixed(2); };
    var total = window.lineTotal(st, sw, S.draft, all);
    var warn = t.querySelector('.warn');
    var parts = groups.map(function (g) {
      var label = g.sizes.length === 1 ? g.sizes[0] : (g.sizes.length === 2 ? g.sizes.join('/') : g.sizes[0] + '–' + g.sizes[g.sizes.length - 1]);
      if (g.sizes.length > 1 && order.indexOf(g.sizes[g.sizes.length - 1]) <= order.indexOf('XL')) label = 'S–XL';
      return '<b>' + g.qty + '</b> ' + label + ' at <b>' + money(g.unit) + '</b>';
    });
    t.innerHTML = parts.join(' · ') + ' · <b>' + money(total) + '</b>' + (warn ? ' ' + warn.outerHTML : '');
  }
  function wrapAddSum() {
    if (typeof window.updateAddSum !== 'function' || window.updateAddSum.__rva) return;
    var orig = window.updateAddSum;
    var w = function (st) {
      var out = orig.apply(this, arguments);
      try { fixAddSum(st); } catch (err) {}
      return out;
    };
    w.__rva = 1;
    window.updateAddSum = w;
  }

  function wrapPhotos() {
    if (typeof window.photo === 'function' && !window.photo.__rva) {
      var origPhoto = window.photo;
      var p = function (st, color, cls) {
        var url = ownPhoto(st, color, cls === 'phBig' ? 1000 : 600);
        if (url) return '<img class="' + cls + '" src="' + url + '" alt="' + st.b + ' ' + st.s + ' in ' + color[0] + '" loading="lazy" decoding="async">';
        return origPhoto.apply(this, arguments);
      };
      p.__rva = 1;
      window.photo = p;
    }
    if (typeof window.setTile === 'function' && !window.setTile.__rva) {
      var origTile = window.setTile;
      var t = function (card, st, f, hex) {
        var url = ownPhoto(st, colorFor(card, st, f, hex), 600);
        var tile = url && card && card.querySelector('.tile');
        if (tile) {
          var cur = tile.querySelector('img.ph') || tile.querySelector('svg');
          if (cur) cur.outerHTML = '<img class="ph" src="' + url + '" alt="" loading="lazy" decoding="async">';
          return;
        }
        return origTile.apply(this, arguments);
      };
      t.__rva = 1;
      window.setTile = t;
    }
  }
  function fixSay() {
    var say = document.getElementById('barSay');
    if (!say || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(say, NodeFilter.SHOW_TEXT, null), node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('—') !== -1) node.nodeValue = node.nodeValue.replace(/\s*—\s*/g, ' · ');
    }
  }
  function watchSay() {
    var say = document.getElementById('barSay');
    if (!say || !window.MutationObserver) return;
    fixSay();
    new MutationObserver(fixSay).observe(say, { childList: true, subtree: true, characterData: true });
  }

  function patchPhotoFail() {
    if (typeof window.rvaPhotoFail !== 'function' || window.rvaPhotoFail.__rva) return;
    var orig = window.rvaPhotoFail;
    var patched = function (img) {
      var src = img.getAttribute('src') || '';
      if (/_f_f[ml]\.jpg/.test(src) && !img.getAttribute('data-model')) {
        img.setAttribute('data-model', '1');
        img.src = src.replace(/_f_(f[ml])\.jpg/, '_omf_$1.jpg');
        return;
      }
      orig(img);
    };
    patched.__rva = 1;
    window.rvaPhotoFail = patched;
  }

  function addThumbStyles() {
    if (document.getElementById('rvaThumbCss')) return;
    var st = document.createElement('style');
    st.id = 'rvaThumbCss';
    st.textContent =
      '#rvaCat .rvaThumbs{display:flex;flex-wrap:wrap;justify-content:center;gap:12px;margin:8px 0 4px;padding:8px 8px 10px;overflow:visible}' +
      '#rvaCat .rvaThumbs[hidden]{display:none}' +
      '#rvaCat .rvaThumb{width:72px;height:72px;padding:7px;border:1px solid #e6e1d8;border-radius:12px;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;overflow:hidden;transition:border-color .15s,outline-color .15s}' +
      '#rvaCat .rvaThumb img{max-width:100%;max-height:100%;width:auto;height:auto;min-width:0;min-height:0;object-fit:contain;display:block}' +
      '#rvaCat .rvaThumb:hover{border-color:#8b8b95}' +
      '#rvaCat .rvaThumb.on{border-color:#e6e1d8;outline:2px solid #24c3f5;outline-offset:2px}' +
      '#rvaCat.rva-style-page .pLeft{overflow:visible!important;max-height:none!important}' +
      '@media (max-width:749px){#rvaCat .rvaThumbs{gap:10px}#rvaCat .rvaThumb{width:60px;height:60px;padding:6px}}';
    document.head.appendChild(st);
  }

  function gallery() {
    var panel = document.getElementById('panel');
    if (!panel) return;
    var tile = panel.querySelector('.pTile');
    if (!tile || !tile.parentNode) return;
    var main = tile.querySelector('img.phBig');
    var old = panel.querySelector('.rvaThumbs');
    var m = main && (main.getAttribute('src') || '').match(RX);
    if (!m) { if (old && old.parentNode) old.parentNode.removeChild(old); return; }
    var id = m[1];
    if (old && old.getAttribute('data-id') === id) return;
    if (old && old.parentNode) old.parentNode.removeChild(old);
    addThumbStyles();
    var box = document.createElement('div');
    box.className = 'rvaThumbs';
    box.setAttribute('data-id', id);
    box.hidden = true;
    tile.parentNode.insertBefore(box, tile.nextSibling);
    var loaded = 0, settled = 0;
    function finish() {
      if (settled < VIEWS.length) return;
      if (loaded < 2) { if (box.parentNode) box.parentNode.removeChild(box); return; }
      var now = tile.querySelector('img.phBig');
      var mm = now && (now.getAttribute('src') || '').match(RX);
      var cur = box.querySelector('[data-v="' + (mm ? mm[2] : m[2]) + '"]') || box.firstChild;
      if (cur) cur.classList.add('on');
      box.hidden = false;
    }
    VIEWS.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rvaThumb';
      b.setAttribute('data-v', v[0]);
      b.setAttribute('aria-label', v[1] + ' photo');
      box.appendChild(b);
      var im = new Image();
      im.alt = '';
      im.decoding = 'async';
      im.onload = function () { loaded++; settled++; b.appendChild(im); finish(); };
      im.onerror = function () { settled++; if (b.parentNode) b.parentNode.removeChild(b); finish(); };
      im.src = SS + id + '_' + v[0] + '_fm.jpg';
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(box.children, function (x) { x.classList.toggle('on', x === b); });
        var cur = tile.querySelector('img.phBig');
        if (!cur) return;
        cur.setAttribute('data-big', '1');
        var hi = new Image();
        hi.onload = function () { cur.src = hi.src; };
        hi.onerror = function () { cur.src = im.src; };
        hi.src = SS + id + '_' + v[0] + '_fl.jpg';
      });
    });
  }
  function watchPanel() {
    var panel = document.getElementById('panel');
    if (!panel || !window.MutationObserver) return;
    gallery();
    panelName();
    new MutationObserver(function () { setTimeout(function () { gallery(); panelName(); }, 0); }).observe(panel, { childList: true });
  }
  function refreshStylePanel() {
    var page = document.querySelector('#rvaCat.rva-style-page');
    if (!page || !window.S || !window.S.open || typeof window.openSheet !== 'function') return;
    window.openSheet();
    document.body.style.overflow = '';
  }

  var minQueued = false;
  function minStyles() {
    if (document.getElementById('rvaMinCss')) return;
    var st = document.createElement('style');
    st.id = 'rvaMinCss';
    st.textContent =
      '#rvaCat .rvaLow{color:#c8322b!important;font-weight:700!important}' +
      '#rvaCat .rvaMinNote{font-size:12px;font-weight:600;margin-left:4px}' +
      '#rvaCat .minWarn{background:#fdecea!important;color:#a8261f!important;border:1px solid #f4c7c2;font-size:13.5px!important;font-weight:700!important}' +
      '#rvaCat .rTbl .rDesc .rDescLink b{color:inherit!important}' +
      '#rvaCat .rTbl .rDesc .rDescLink:hover{text-decoration:underline}';
    document.head.appendChild(st);
  }
  function flagMin() {
    minQueued = false;
    if (typeof window.reqPieces !== 'function') return;
    var n = window.reqPieces(), low = n > 0 && n < MIN;
    minStyles();
    Array.prototype.forEach.call(document.querySelectorAll('#rvaCat .totals > div'), function (row) {
      var k = row.firstElementChild, v = row.lastElementChild;
      if (!k || !v || k === v || k.textContent.trim() !== 'Pieces') return;
      v.classList.toggle('rvaLow', low);
      var note = v.querySelector('.rvaMinNote');
      if (low && !note) { note = document.createElement('span'); note.className = 'rvaMinNote'; note.textContent = '(min ' + MIN + ')'; v.appendChild(note); }
      if (!low && note) note.parentNode.removeChild(note);
    });
    ['rTblN', 'rBarN'].forEach(function (id) { var el = document.getElementById(id); if (el) el.classList.toggle('rvaLow', low); });
    var say = document.getElementById('rSay');
    if (say && low && !say.querySelector('.rvaLow')) say.innerHTML = say.innerHTML.replace(/(\d+ pieces?)/, '<span class="rvaLow">$1</span>');
    Array.prototype.forEach.call(document.querySelectorAll('#rvaCat .minWarn'), function (w) {
      var t = w.textContent, m = t.match(/add (\d+) more/i);
      if (m && t.indexOf('—') !== -1) w.textContent = 'Below the ' + MIN + '-piece minimum. Add ' + m[1] + ' more to send this request.';
    });
  }
  function queueMin() {
    if (minQueued) return;
    minQueued = true;
    (window.requestAnimationFrame || setTimeout)(flagMin);
  }
  function watchMin() {
    var root = document.getElementById('rvaCat');
    if (!root || !window.MutationObserver) return;
    flagMin();
    new MutationObserver(queueMin).observe(root, { childList: true, subtree: true, characterData: true });
  }

  (function wait() {
    if (ready()) {
      patchPhotoFail();
      wrapPhotos();
      wrapCards();
      wrapRender();
      wrapAddSum();
      navFocusCss();
      if (typeof window.render === 'function') { try { window.render(); } catch (err) {} }
      heading();
      refreshStylePanel();
      watchSay();
      watchPanel();
      watchMin();
      return;
    }
    if (++tries < 400) setTimeout(wait, 25);
  })();
})();